import {
  Mail, Phone, MessageSquare, CreditCard, ShoppingBag, Briefcase, Calendar,
  Trophy, Star, Heart, Music, Video, Info, Download,
} from 'lucide-react'
import {
  FaLinkedin, FaGithub, FaInstagram, FaFacebook,
  FaYoutube, FaTiktok, FaWhatsapp, FaGoogle, FaSpotify,
  FaApple, FaSnapchat, FaPinterest, FaTelegram, FaDiscord,
  FaTwitch, FaReddit, FaMedium, FaBehance, FaDribbble, FaGlobe,
  FaSoundcloud, FaAmazon, FaEtsy, FaPatreon,
  FaVimeo, FaTumblr, FaFlickr, FaDeezer, FaBandcamp,
  FaGitlab, FaStackOverflow, FaSkype, FaYelp, FaPaypal,
} from 'react-icons/fa'
// Nécessite react-icons >= 5
import { FaXTwitter, FaThreads } from 'react-icons/fa6'

export const ICON_CATEGORIES = {
  'Réseaux sociaux': [
    { id: 'instagram', label: 'Instagram', icon: FaInstagram, color: '#e1306c' },
    { id: 'facebook', label: 'Facebook', icon: FaFacebook, color: '#1877f2' },
    { id: 'twitter', label: 'X (Twitter)', icon: FaXTwitter, color: '#000000' },
    { id: 'threads', label: 'Threads', icon: FaThreads, color: '#000000' },
    { id: 'linkedin', label: 'LinkedIn', icon: FaLinkedin, color: '#0a66c2' },
    { id: 'tiktok', label: 'TikTok', icon: FaTiktok, color: '#000000' },
    { id: 'youtube', label: 'YouTube', icon: FaYoutube, color: '#ff0000' },
    { id: 'snapchat', label: 'Snapchat', icon: FaSnapchat, color: '#fffc00' },
    { id: 'pinterest', label: 'Pinterest', icon: FaPinterest, color: '#e60023' },
    { id: 'twitch', label: 'Twitch', icon: FaTwitch, color: '#9146ff' },
    { id: 'discord', label: 'Discord', icon: FaDiscord, color: '#5865f2' },
    { id: 'telegram', label: 'Telegram', icon: FaTelegram, color: '#0088cc' },
    { id: 'reddit', label: 'Reddit', icon: FaReddit, color: '#ff4500' },
    { id: 'medium', label: 'Medium', icon: FaMedium, color: '#000000' },
    { id: 'behance', label: 'Behance', icon: FaBehance, color: '#1769ff' },
    { id: 'dribbble', label: 'Dribbble', icon: FaDribbble, color: '#ea4c89' },
    { id: 'vimeo', label: 'Vimeo', icon: FaVimeo, color: '#1ab7ea' },
    { id: 'tumblr', label: 'Tumblr', icon: FaTumblr, color: '#36465d' },
    { id: 'flickr', label: 'Flickr', icon: FaFlickr, color: '#0063dc' },
    { id: 'gitlab', label: 'GitLab', icon: FaGitlab, color: '#fc6d26' },
    { id: 'stackoverflow', label: 'Stack Overflow', icon: FaStackOverflow, color: '#f48024' },
    { id: 'skype', label: 'Skype', icon: FaSkype, color: '#00aff0' },
    { id: 'yelp', label: 'Yelp', icon: FaYelp, color: '#d32323' },
  ],
  'Communication': [
    { id: 'whatsapp', label: 'WhatsApp', icon: FaWhatsapp, color: '#25d366' },
    { id: 'email', label: 'Email', icon: Mail, color: '#0F1B3D' },
    { id: 'phone', label: 'Téléphone', icon: Phone, color: '#0F1B3D' },
    { id: 'message', label: 'Message', icon: MessageSquare, color: '#0F1B3D' },
    { id: 'google', label: 'Google Reviews', icon: FaGoogle, color: '#ea4335' },
  ],
  'Musique / créateur': [
    { id: 'spotify', label: 'Spotify', icon: FaSpotify, color: '#1db954' },
    { id: 'apple', label: 'Apple Music', icon: FaApple, color: '#fa243c' },
    { id: 'soundcloud', label: 'SoundCloud', icon: FaSoundcloud, color: '#ff5500' },
    { id: 'deezer', label: 'Deezer', icon: FaDeezer, color: '#a238ff' },
    { id: 'bandcamp', label: 'Bandcamp', icon: FaBandcamp, color: '#629aa9' },
    { id: 'patreon', label: 'Patreon', icon: FaPatreon, color: '#f96854' },
  ],
  'Commerce': [
    { id: 'amazon', label: 'Amazon', icon: FaAmazon, color: '#ff9900' },
    { id: 'etsy', label: 'Etsy', icon: FaEtsy, color: '#f56400' },
    { id: 'paypal', label: 'PayPal', icon: FaPaypal, color: '#003087' },
    { id: 'payment', label: 'Paiement', icon: CreditCard, color: '#0F1B3D' },
    { id: 'shop', label: 'Boutique', icon: ShoppingBag, color: '#0F1B3D' },
  ],
  'Autres': [
    { id: 'website', label: 'Site web', icon: FaGlobe, color: '#64748b' },
    { id: 'portfolio', label: 'Portfolio', icon: Briefcase, color: '#0F1B3D' },
    { id: 'calendar', label: 'Calendrier', icon: Calendar, color: '#0F1B3D' },
    { id: 'trophy', label: 'Récompense', icon: Trophy, color: '#0F1B3D' },
    { id: 'star', label: 'Étoile', icon: Star, color: '#c9a961' },
    { id: 'heart', label: 'Favoris', icon: Heart, color: '#ef4444' },
    { id: 'music', label: 'Musique', icon: Music, color: '#1db954' },
    { id: 'video', label: 'Vidéo', icon: Video, color: '#ff0000' },
    { id: 'github', label: 'GitHub', icon: FaGithub, color: '#181717' },
    { id: 'info', label: 'Info', icon: Info, color: '#0F1B3D' },
    { id: 'help', label: 'Aide', icon: MessageSquare, color: '#0F1B3D' },
    { id: 'download', label: 'Télécharger', icon: Download, color: '#0F1B3D' },
  ],
}

export const ALL_PLATFORMS = Object.values(ICON_CATEGORIES).flat()

export const PLATFORMS = ALL_PLATFORMS.reduce((acc, p) => {
  acc[p.id] = p
  return acc
}, {})

// Anciens ids sauvegardés -> ids actuels
const ALIASES = { apple_music: 'apple', x: 'twitter' }

export const getPlatform = (id) => PLATFORMS[ALIASES[id] || id] || PLATFORMS.website